import type { CSSProperties } from "react";

import type { YardType } from "@yfp/types";
import { COLORS } from "./index";

/** Simulated delay before showing the map after address selection (UX placeholder). */
export const AERIAL_VIEW_TRANSITION_MS = 1500;

/** Debounce for Google Places autocomplete requests. */
export const PLACES_AUTOCOMPLETE_DEBOUNCE_MS = 300;

export const DASHBOARD_PROJECTS_PAGE_SIZE = 6;

export const DASHBOARD_SEARCH_DEBOUNCE_MS = 300;

export const SNACKBAR_AUTO_HIDE_MS = 3000;

export const CLIENT_NAME_REQUIRED_MESSAGE = "Please enter the client's name";

/** Dark grid overlay used on full-bleed new-project screens. */
export const DARK_GRID_BACKGROUND_STYLE: CSSProperties = {
  backgroundImage:
    "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
  backgroundSize: "40px 40px",
};

export const NEW_PROJECT_PAGE_BG = COLORS.background;

export const PROPERTY_PHOTO_INSTRUCTIONS = [
  "Take the photo during daylight hours for best results",
  "Hold your phone horizontally (landscape mode)",
  "Position yourself so the entire yard is visible and centered",
];

export const PROPERTY_PHOTO_GUIDE_ILLUSTRATION =
  "/assets/back-yard-template.png";

export const PROPERTY_PHOTO_EXAMPLE_IMAGE_URL =
  "https://yardai-sample-images.s3.us-east-1.amazonaws.com/style_references/yard_examples/before-back.jpg";

/**
 * Spaces a contractor can add to a single project. Each space carries its own
 * photo + generation results, and stores its exact `yardType`. Style references
 * only exist for front/back, so non-front types map to the back-yard library at
 * lookup time (see `toStyleReferenceYardType`).
 */
export type SpaceOption = {
  label: string;
  yardType: YardType;
};

export const SPACE_OPTIONS: readonly SpaceOption[] = [
  { label: "Front Yard", yardType: "FRONT_YARD" },
  { label: "Backyard", yardType: "BACK_YARD" },
  { label: "Side Yard", yardType: "SIDE_YARD" },
  { label: "Full Property", yardType: "FULL_PROPERTY" },
] as const;

/**
 * Fallback yard type when the flow hasn't captured one. Front/back selection was
 * removed from the wizard, so generation defaults to the back-yard library.
 */
export const DEFAULT_YARD_TYPE: YardType = "BACK_YARD";
